import React, { useEffect, useRef, useState } from 'react'
import { Accordion, Col, Row } from 'react-bootstrap';
import CustomSelect from '../../Utilities/CustomSelect';
import { CoursesManangementVM } from '../../../Structure/ViewModels/Admin/CoursesManagementVM';
import { PackagesListsVM } from '../../../Structure/ViewModels/Admin/PackagesListsVM';
import { CoursesListVM } from '../../../Structure/ViewModels/Admin/CoursesListVM';

const PackagesLists = (props:{vm:CoursesManangementVM , coursesVM:CoursesListVM}) => {
    const [parent , setParent] = useState<{viewModel:CoursesManangementVM}>({viewModel:props.vm})
    const [coursesVM , setCoursesVM] = useState<{viewModel:CoursesListVM}>({viewModel:props.coursesVM})
    const [vm , setVm] = useState<{viewModel:PackagesListsVM}>({viewModel: new PackagesListsVM()})
    const control = vm.viewModel

    useEffect(()=>{
        control.subscribeUpdate(setVm)
        parent.viewModel.subscribeUpdate(setParent)
        coursesVM.viewModel.subscribeUpdate(setCoursesVM)
    },[])

    useEffect(()=>{ if(parent.viewModel.Specializations) control.Specializations = parent.viewModel.Specializations } ,[parent.viewModel.Specializations])
    useEffect(()=>{ if(parent.viewModel.Levels){ control.Levels = parent.viewModel.Levels; } },[parent.viewModel.Levels])
    useEffect(()=>{ if(coursesVM.viewModel.CoursesList){ control.AllCourses = coursesVM.viewModel.CoursesList.map(i=>({course:i , visiblity:true})); } },[coursesVM.viewModel.CoursesList])
    
    const addingButtonRef = useRef<HTMLDivElement>(null)
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>)=>{
        if(event.key === 'Enter' && addingButtonRef.current){
            addingButtonRef.current.click()
        }
    }

  return (
    <Accordion defaultActiveKey={'0'} className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
        <Accordion.Item eventKey='0' className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}} >
            <Accordion.Button  className='border-0 border-bottom' style={{outline:'none', border:'none' , borderRadius:'0px', boxShadow:'none'}}>
                <h5 className='ps-3 px-2'>المسارات</h5>
            </Accordion.Button>
            <Accordion.Body  className=' d-flex flex-column justify-content-between overflow-y-auto'   style={{height:'400px'}}>
            {
                            control.ShowWithMessege(<Row className='h-100'>

                    <Col xl={4} className='d-flex p-3 flex-column justify-content-between h-100'>
                        <div className='d-flex flex-column ps-5 h-100'>
                            <CustomSelect list={control.Specializations?.map(i=>({label:i.value , value:i.id}))} selected={control.Specialization} onSelect={a=>control.Specialization=a}  />
                        </div>
                        <div className='d-flex flex-column ps-5 h-100'>
                            <CustomSelect list={control.Levels?.map(i=>({label:i.value , value:i.id}))} selected={control.Level} onSelect={a=>control.Level = a} />
                        </div>
                        <div className='d-flex ps-5 h-100'>
                            <div className='d-flex flex-column w-100'>
                                <div className='d-flex w-100'>
                        
                                    <input type="text" className='input-field w-100' onKeyDown={handleKeyDown} value={control.Price} onChange={a=>control.Price = a.target.value} />
                                    <div className='px-2'></div>
                                    <div ref={addingButtonRef} className='material-symbols-outlined success-item c-pointer m-auto fs-3' onClick={()=>control.changePrice()}>save</div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xl={4} className=' p-3  h-100'>
                        <div className='border p-1 h-100 overflow-y-auto'>
                            {
                                control.CurrentCourses.map((item,index)=>(
                                    <div key={index} className='d-flex justify-content-between py-3 px-1'
                                        style={{background:index%2?'rgba(250,250,250,0.5)':'rgba(240,240,240,1)'}}    >
                                        <div>{item.course}</div>
                                        <div>
                                            <button className='button-II btn-cl-I ' onClick={()=>control.removeCourse(item)}>ازالة</button>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </Col>
                    <Col xl={4} className=' p-3 h-100'>
                        <div className='border p-1 h-100 overflow-y-auto'>
                            {
                                control.AllCourses.map((item,index)=>
                                    item.visiblity?(
                                    <div key={index} className='d-flex justify-content-between py-3 px-1'
                                        style={{background:index%2?'rgba(250,250,250,0.5)':'rgba(240,240,240,1)'}}    >
                                        <div>{item.course.course}</div>
                                        <div>
                                            <button className='button-II btn-cl-I' onClick={()=>control.addCourse(item.course)}>اضافة</button>
                                        </div>
                                    </div>):(null)
                                )
                            }
                        </div>
                    </Col>
                </Row>)
            }
            </Accordion.Body>
        </Accordion.Item>
    </Accordion>
  )
}

export default PackagesLists
